import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useMyHeritageHintsFlag(): CachedFlag<'myHeritageHints'> {
  return useCachedFlag('myHeritageHints')
}
